export const Storage = {
  set (key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  get (key, initialValue) {
    const value = JSON.parse(localStorage.getItem(key))
    return value || initialValue
  }
}



// WEBPACK FOOTER //
// ./src/Storage.js